import React from 'react'
import './Header.css'
import logoBlanco from '../../img/logo-tec-blanco.svg'

function Header() {
  
  return (
    <div className='header'>
        <img id="imgLogoBlanco" src={logoBlanco} />
    </div>
  )
}

export default Header